import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { classNames } from "primereact/utils";
import { AdminPageHeader } from "../components/AdminPageHeader";

const tiles = [
    {
        title: "Rides",
        subtitle: "Trip list, status, and full detail for each booking.",
        icon: "pi pi-map",
        to: "/rides",
    },
    {
        title: "Live map",
        subtitle: "Online drivers: green free, yellow accepted, red ongoing.",
        icon: "pi pi-map-marker",
        to: "/map",
    },
    {
        title: "Trip reports",
        subtitle: "Receipt filters, taxes, fees, and driver earnings.",
        icon: "pi pi-chart-bar",
        to: "/reports",
    },
    {
        title: "Withdrawal & Revenue",
        subtitle: "Date-range trips by driver; mark payouts as paid.",
        icon: "pi pi-wallet",
        to: "/withdrawals",
    },
    {
        title: "Coupons",
        subtitle: "Promo codes: flat or %, date window, and first-N-rides limits.",
        icon: "pi pi-ticket",
        to: "/coupons",
    },
    {
        title: "Passengers",
        subtitle: "Rider accounts, contact details, and activity.",
        icon: "pi pi-users",
        to: "/passengers",
    },
    {
        title: "Drivers",
        subtitle: "Partner profiles, onboarding, and approvals.",
        icon: "pi pi-id-card",
        to: "/drivers",
    },
    {
        title: "Settings",
        subtitle: "Base price, city fee, waiting, cancellation, and map default.",
        icon: "pi pi-cog",
        to: "/settings",
    },
];

export default function DashboardHome() {
    const navigate = useNavigate();

    return (
        <div>
            <AdminPageHeader
                title="Dashboard"
                subtitle="Overview of operations. Open a section below to work with live data."
            />
            <div className="grid">
                {tiles.map((t) => (
                    <div key={t.to} className="col-12 md:col-4">
                        <Card
                            className={classNames(
                                "uc-admin-dash-tile",
                                "surface-card",
                                "cursor-pointer",
                                "h-full",
                                "border-none",
                            )}
                            onClick={() => navigate(t.to)}
                        >
                            <div className="flex gap-3 align-items-start">
                                <div className="uc-admin-dash-tile-icon flex align-items-center justify-content-center flex-shrink-0">
                                    <i className={classNames(t.icon, "text-xl")} aria-hidden />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="uc-admin-dash-tile-title text-lg font-bold text-900">{t.title}</div>
                                    <p className="text-600 mt-2 mb-0 text-sm line-height-3">{t.subtitle}</p>
                                    <div className="uc-admin-dash-tile-cta mt-3 flex align-items-center text-primary text-sm">
                                        Open section
                                        <i className="pi pi-arrow-right ml-2 text-xs" aria-hidden />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
}
